import { css } from "@emotion/react";
import { DesignComponent } from "@minted/fancyclothes";
import { styleUtils, theme } from "@minted/minted-components";
import React from "react";

interface ListNumberProps {
  children: React.ReactNode;
}

class ListNumber extends DesignComponent {
  props?: ListNumberProps;

  render() {
    const { children } = this.props!;
    const { fontFamily } = (this as any).getFontStyles({}, "DesignProvider");

    const style = css`
      align-items: center;
      background-color: ${(this as any).getRule("fontColor", "DesignProvider")};
      border-radius: 50%;
      color: ${(this as any).getRule("backgroundColor", "DesignProvider")};
      display: flex;
      font-family: ${fontFamily};
      height: ${styleUtils.rem(30)};
      justify-content: center;
      text-align: center;
      width: ${styleUtils.rem(30)};
      ${theme.media.lessThan(theme.breakpoints.medium)(`
        display: none;
      `)}
    `;
    const customStyle = (this as any).getFontSizeStyles(
      16,
      {},
      "DesignProvider",
    );

    return <div css={[style, customStyle]}>{children}</div>;
  }
}

export default ListNumber;
